import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import FeedbackModal from "../shared/FeedbackModal";
import { logoutUser } from "../../store/actions/authActions";

const Footer = ({ logoutUserAction }) => {
  const location = useLocation();
  const [feedbackOpen, setFeedbackOpen] = useState(false);

  return (
    <>
      <div id="footer-bar" className="footer-bar-1">
        <Link to="/">
          <i className="fa fa-home"></i>
          <span>Home</span>
        </Link>
        <Link to="/choosetype" className={location.pathname === "/choosetype" ? "active-nav" : ""}>
          <i className="fa fa-list"></i>
          <span>Choose Type</span>
        </Link>
        <Link to="/contact" className={location.pathname === "/contact" ? "active-nav" : ""}>
          <i className="fa fa-envelope"></i>
          <span>Contact</span>
        </Link>
        <a
          onClick={(e) => {
            e.preventDefault();
            if (typeof window.openXlog3DHelp === "function") {
              window.openXlog3DHelp();
            } else {
              window.dispatchEvent(new Event("xlog3d:open-help"));
            }
          }}
          style={{ cursor: "pointer", color: "#c0392b" }}
        >
          <i className="fa fa-info-circle" style={{ color: "#c0392b" }}></i>
          <span style={{ color: "#c0392b", fontWeight: 700 }}>User Manual</span>
        </a>
        <a
          onClick={(e) => {
            e.preventDefault();
            setFeedbackOpen(true);
          }}
          style={{ cursor: "pointer" }}
        >
          <i className="fa fa-sign-out-alt"></i>
          <span>Exit</span>
        </a>
      </div>
      <FeedbackModal
        open={feedbackOpen}
        onClose={() => setFeedbackOpen(false)}
        screenLabel={`Exit (${location.pathname})`}
        attachGraph={false}
        redirectUrl="https://www.dhawanacademy.com/"
        // Exit means exit: end the session rather than leaving it open for
        // whoever opens this browser next.
        onBeforeLeave={logoutUserAction}
      />
    </>
  );
};

export default connect(null, { logoutUserAction: logoutUser })(Footer);
